import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { Field, getFormValues, reduxForm, reset } from 'redux-form';
import OperatorInputField from 'components/input/OperatorInputField';
import ProductAttributeInput from 'components/input/ProductAttributeInput';
import RenderTextInputField from 'components/form/InputFields/RenderTextInputField';
import { productAttributeFields } from 'helpers/product';
import { getRuleConfig } from 'helpers/rulesHelper';
import styled from 'styled-components';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';
import validations from 'helpers/forms/validations';

const StyledInputWrapper = styled.div`
    display: flex;
    flex-direction: column;
`;

class ProductAttributeRule extends Component {
    componentDidMount() {
        const {
            initialize,
            type,
            value,
        } = this.props;

        const initialState = {
            attribute: value.attribute || 'id',
            operator: value.operator || null,
            value: value.value || null,
        };

        const config = getRuleConfig(utils.firstCharToLowerCase(type)).config;

        if (utils.hasKey(config, 'count')) {
            initialState.count = value.count || null;
        }

        initialize(initialState);
    }

    componentDidUpdate(prevProps) {
        const {
            formValues,
            initialize,
            onUpdate,
        } = this.props;

        const diffFormValues = utils.diffObjects(formValues, prevProps.formValues);
        const requiresCount = utils.hasKey(formValues, 'count');

        if (!!diffFormValues.attribute && Object.values(diffFormValues).length === 1) {
            const newValues = { ...formValues };

            newValues.operator = null;
            newValues.value = null;

            if (requiresCount) {
                newValues.count = null;
            }

            initialize(newValues);

            return reset();
        }

        if (!utils.isEmpty(diffFormValues)) {
            return onUpdate(formValues);
        }
    }

    render() {
        const {
            formValues,
            translate,
        } = this.props;

        if (!formValues) {
            return null;
        }

        const {
            attribute,
        } = formValues;

        const requiresCount = utils.hasKey(formValues, 'count');

        const ValueComponent = productAttributeFields[attribute];

        return (
            <StyledInputWrapper>
                <Field
                    component={ ProductAttributeInput }
                    label={ translate('resources.products.attribute') }
                    name='attribute'
                    validate={ validations.required }
                />

                { requiresCount &&
                    <Field
                        component={ RenderTextInputField }
                        label={ translate('resources.products.count') }
                        name='count'
                        validate={ [
                            validations.required,
                            validations.number,
                        ] }
                    />
                }

                <Field
                    component={ OperatorInputField }
                    name='operator'
                    validate={ validations.required }
                />

                <Field
                    component={ ValueComponent }
                    label={ translate('resources.products.value.label') }
                    name='value'
                    validate={ validations.required }
                />

            </StyledInputWrapper>
        );
    }
}

ProductAttributeRule.propTypes = {
    formValues: PropTypes.shape({
        attribute: PropTypes.string,
        count: PropTypes.string,
        operator: PropTypes.string,
        value: PropTypes.oneOfType([
            PropTypes.array,
            PropTypes.bool,
            PropTypes.number,
            PropTypes.string,
        ]),
    }),
    initialize: PropTypes.func.isRequired,
    onUpdate: PropTypes.func,
    translate: PropTypes.func.isRequired,
    type: PropTypes.string.isRequired,
    value: PropTypes.shape({
        attribute: PropTypes.string,
        count: PropTypes.string,
        operator: PropTypes.string,
        value: PropTypes.oneOfType([
            PropTypes.array,
            PropTypes.bool,
            PropTypes.number,
            PropTypes.string,
        ]),
    }),
};

const mapStateToProps = (state, props) => {
    const {
        id,
        type,
    } = props;

    const form = `productAttribute-${ type }-${ id }`;

    return {
        form: form,
        formValues: getFormValues(form)(state),
    };
};

const enhance = compose(
    translate,
    connect(mapStateToProps, null),
    reduxForm(),
);

export default enhance(ProductAttributeRule);


// WEBPACK FOOTER //
// ./src/pages/discounts/rules/ProductAttributeRule.js